module.exports = __webpack_public_path__ + "img/part6.48cc9a04.png";